import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router';
import axios from 'axios'
import * as VueGoogleMaps from 'vue2-google-maps';
import VueGeolocation from 'vue-browser-geolocation';
import VueElementLoading from 'vue-element-loading';
import VueApexCharts from 'vue-apexcharts';
import ServerError from './components/common/500';
Vue.component('ServerError', ServerError)
Vue.use(VueApexCharts)
Vue.component("VueElementLoading", VueElementLoading);
Vue.component('apexchart', VueApexCharts)
Vue.component('VueElementLoading', VueElementLoading)
Vue.config.productionTip = false
Vue.use(VueGeolocation);
Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyCaccNxbzwR9tMvkppT7bT7zNKjChc_yAw',
        libraries: 'places',
    },
})

window.axios = require('axios')
    // axios.defaults.baseURL = 'http://192.168.50.75:3200';
axios.defaults.baseURL = 'http://3.108.61.36/'
Vue.prototype.baseURL = "http://3.108.61.36/"
Vue.prototype.mediaURL = "http://3.108.61.36/u/"
    // Vue.prototype.axios = axios
new Vue({
    vuetify,
    router,
    render: h => h(App)
}).$mount('#app')